export default __webpack_public_path__ + "static/media/1990.0a63eb35.png";